import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/home.vue"; // 页面整体布局
import secondaryMenu from "@/layout/secondaryMenu.vue"; // 页面整体布局
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

const routes = [{
  path: "/",
  redirect: "/cockpit",
  hidden: true,
},
{
  path: "/cockpit",
  name: "cockpit",
  component: res => import("views/cockpit/index.vue"),
},
 
];

const router = new VueRouter({
  routes,
});

export default router;